export default __webpack_public_path__ + "26ccacf.png";